import { getFileType } from 'utils/attachmentPreview.utils';
import {
    Box,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    ModalCloseButton,
    Image,
    Text,
} from '@chakra-ui/react';

const AttachmentPreviewModal = ({ attachment, onClose }) => {
    if (!attachment) return null;
  
    const type = getFileType(attachment.file_name);
  
    return (
      <Modal isOpen={true} onClose={onClose} size="full">
        <ModalOverlay bg="blackAlpha.800" backdropFilter="blur(2px)" />
        <ModalContent w="100%" h="100%" maxW="100%" maxH="100%" m={0} borderRadius={0} bg="transparent" boxShadow="none">
          <ModalCloseButton color="white" zIndex={10} />
          <ModalBody p={4} h="100%" display="flex" alignItems="center" justifyContent="center" bg="transparent">
            {type === 'image' && (
              <Image
                src={attachment.file_url}
                maxH="100%"
                maxW="100%"
                mx="auto"
                borderRadius="md"
                objectFit="contain"
              />
            )}

            {type === 'pdf' && (
              <iframe
                src={attachment.file_url}
                title="PDF Preview"
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            )}

            {
              type === 'text' && (
              <Box
                src={attachment.file_url}
                title="Text Preview"
                style={{ width: '100%', height: '100%', border: 'none' }}
              />
            )}

            {type === 'other' && (
              <Text textAlign="center" py={10} color='white'>
                Preview not available. Please download the file.
              </Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  };

export default AttachmentPreviewModal;